import initialState from "../../data/privaGlobal";
import ActionTypes from "../constants/action-types";

const privaGlobal = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_DARKMODE:
            return {
                ...state,
                darkmode: action.payload,
            };
        case ActionTypes.SET_SETTINGS_MAX_PPV_PRICE:
            return {
                ...state,
                settings: {
                    ...action.payload,
                },
            };

        case ActionTypes.SET_SHOW_ALERT:
            return {
                ...state,
                alert: {
                    ...action.payload,
                },
            };
        case ActionTypes.SET_SETTINGS:
            let tmpSettings = {};

            action.payload.forEach((setting) => {
                const keys = Object.keys(setting);
                tmpSettings[keys[0]] = setting[keys[0]];
            });

            return {
                ...state,
                settings: {
                    ...tmpSettings,
                },
            };
        case ActionTypes.SET_CC_FORM:
            return {
                ...state,
                creditCardForm: {
                    ...state.creditCardForm,
                    ...action.payload,
                },
            };
        case ActionTypes.TOGGLE_CC_FORM:
            return {
                ...state,
                creditCardForm: {
                    ...state.creditCardForm,
                    show: action.payload,
                },
            };
        case ActionTypes.TOGGLE_TIP:
            return {
                ...state,
                tipForm: {
                    ...state.tipForm,
                    show: action.payload,
                },
            };
        case ActionTypes.SET_TIP_POST_ID:
            return {
                ...state,
                tipForm: {
                    ...state.tipForm,
                    postId: action.payload,
                },
            };
        case ActionTypes.SET_TIP_NEXT_ACTION:
            return {
                ...state,
                tipForm: {
                    ...state.tipForm,
                    nextAction: action.payload,
                },
            };

        default:
            return state;
    }
};

export default privaGlobal;
